/**
 * The entry point for the admin side wp-admin resource.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/antd.scss";
import { createRoot } from "react-dom/client";
import { ready, waitObject } from "@devowl-wp/react-utils";
import { ErrorModal } from "./components/errorModal/modal.js";
import { Provider } from "./components/provider.js";
import { createActivityDetector } from "./queue/activityDetector.js";
import { fetchStatus } from "./queue/fetchStatus.js";
import { refreshQueue } from "./queue/refreshQueue.js";
import { restoreJobsFromLocalStorage } from "./queue/restoreFromLocalStorage.js";
import { checkWorkerNotifications } from "./queue/tabBridge/checkNotifications.js";
import { clearWorkerNotifications } from "./queue/tabBridge/clearNotifications.js";
import { lockTab } from "./queue/tabBridge/lockTab.js";
import { CLIENT_JOB_EVENT_PREFIX } from "./types/events/clientJob.js";
ready(async ()=>{
    // Only allow queue runtime for one tab
    await waitObject(()=>lockTab() ? undefined : "unlocked", 3000);
    window.addEventListener("beforeunload", ()=>lockTab(false));
    lockTab(true);
    // Create error modal
    const errorModalElement = document.createElement("div");
    document.body.appendChild(errorModalElement);
    createRoot(errorModalElement).render(/*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(ErrorModal, {})
    }));
    // Mark this tab as worker
    clearWorkerNotifications();
    window.realQueueWorker = true;
    setInterval(()=>checkWorkerNotifications({
            refreshQueue
        }), 3000);
    const addedFromLocalStorage = await restoreJobsFromLocalStorage();
    if (!addedFromLocalStorage) {
        // No new items from LocalStorage, check if queue has new items
        refreshQueue(false);
    }
}, "interactive");
ready(()=>{
    createActivityDetector();
    fetchStatus(60000);
    // When the tab gets visible, immediate fetch status
    document.addEventListener("visibilitychange", ()=>{
        if (document.visibilityState === "visible") {
            fetchStatus(true);
        }
    });
});
// Example implementation of a client job
document.addEventListener(`${CLIENT_JOB_EVENT_PREFIX}example`, async ({ detail: { job, resolve, fetchJob, saveJobResult } })=>{
    console.log("Lock this job and sleep...", job);
    const { id, process_total } = job;
    await fetchJob(id, true);
    await new Promise((resolve)=>setTimeout(resolve, 5000));
    saveJobResult(id, process_total);
    resolve();
});
export * from "./hooks/index.js";
export * from "./types/index.js";
export * from "./utils/index.js";
export * from "./queue/index.js";
export * from "./wp-api/index.js";
